import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

// ══════════════════════════════════════════════════════════════════════════════
// FIX GLOBAL: Le script Emergent (emergent-main.js) intercepte window.fetch
// et window.parent.postMessage. Quand une réponse non-OK est reçue, il lit
// response.text() ce qui consomme le body stream, puis notre code ne peut
// plus lire la réponse. Il appelle aussi postMessage avec des objets
// non-clonables, ce qui throw "Request object could not be cloned".
//
// Solution: recréer un fetch propre à partir de fetch.bind(window) et
// patcher postMessage pour ignorer les erreurs de clonage.
// ══════════════════════════════════════════════════════════════════════════════

// 1. Restaurer un fetch propre (contourne l'interception Emergent)
//    On crée un iframe invisible pour obtenir un fetch non-patché
try {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  document.head.appendChild(iframe);
  if (iframe.contentWindow && iframe.contentWindow.fetch) {
    window.fetch = iframe.contentWindow.fetch.bind(window);
  }
  document.head.removeChild(iframe);
} catch (e) {
  // Fallback: si l'iframe ne marche pas, on garde le fetch actuel
}

// 2. Patcher postMessage pour ignorer les erreurs de clonage
const _origPostMessage = window.postMessage.bind(window);
window.postMessage = function (message, ...rest) {
  try {
    return _origPostMessage(message, ...rest);
  } catch (e) {
    if (e && e.message && e.message.includes('could not be cloned')) {
      return; // Silently ignore
    }
    throw e;
  }
};

// 3. Supprimer les erreurs non-critiques dans les handlers globaux
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('could not be cloned')) {
    e.preventDefault();
    return false;
  }
}, true);
window.addEventListener('unhandledrejection', (e) => {
  const msg = String(e.reason?.message || e.reason || '');
  if (msg.includes('could not be cloned')) {
    e.preventDefault();
    return false;
  }
}, true);

// 4. Cacher le badge "Made with Emergent" lors de l'impression.
//    Le badge a `display: inline-flex !important` en inline style, ce qui bat
//    notre CSS @media print. On force avec JS via beforeprint/afterprint.
(function setupHideEmergentBadgeOnPrint() {
  const hide = () => {
    document.querySelectorAll(
      '#emergent-badge, [data-emergent-badge], a[href*="emergentagent.com"], a[href*="emergent.sh"]'
    ).forEach((el) => {
      if (!el.dataset.prevDisplayCaptured) {
        el.dataset.prevDisplay = el.style.display || '';
        el.dataset.prevVisibility = el.style.visibility || '';
        el.dataset.prevDisplayCaptured = '1';
      }
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
    });
  };
  const restore = () => {
    document.querySelectorAll(
      '#emergent-badge, [data-emergent-badge], a[href*="emergentagent.com"], a[href*="emergent.sh"]'
    ).forEach((el) => {
      if (el.dataset.prevDisplayCaptured) {
        el.style.display = el.dataset.prevDisplay || '';
        el.style.visibility = el.dataset.prevVisibility || '';
        delete el.dataset.prevDisplay;
        delete el.dataset.prevVisibility;
        delete el.dataset.prevDisplayCaptured;
      }
    });
  };
  window.addEventListener('beforeprint', hide);
  window.addEventListener('afterprint', restore);
  // Aussi via matchMedia (Safari)
  if (window.matchMedia) {
    const mql = window.matchMedia('print');
    mql.addEventListener?.('change', (mq) => (mq.matches ? hide() : restore()));
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Désactiver le service worker — cause des conflits de cache sur mobile
serviceWorkerRegistration.unregister();
